import React from "react";
import { motion, AnimatePresence } from "framer-motion";

import carrotInitial from "../../assets/games/picnic-game/carrot-chef/carrot-initial.png";
import carrotPreparing from "../../assets/games/picnic-game/carrot-chef/carrot-preparing.png";
import carrotSelecting from "../../assets/games/picnic-game/carrot-chef/carrot-selecting.png";

/* animation imports */
import { elementsEntryExit } from "../../assets/js/animations";

const PicnicLeftArea = ({
  showStoryStart,
  showStoryEnd,
  dishType,
  calculateIsActive,
  gameDisclaimerAccepted,
  isGameStart,
}) => {
  return (
    <div className="picnic-left-area">
      <div className="carrot-chef-wrapper">
        <AnimatePresence>
          {!showStoryStart &&
            !showStoryEnd &&
            gameDisclaimerAccepted &&
            isGameStart && (
              <motion.img
                src={
                  dishType === ""
                    ? carrotInitial
                    : calculateIsActive
                    ? carrotPreparing
                    : carrotSelecting
                }
                alt="carrot chef"
                variants={elementsEntryExit}
                initial="initial"
                animate="animate"
                exit="exit"
              />
            )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default PicnicLeftArea;
